<template>
  <Modal v-bind="$attrs" @open="onModalOpen" @cancel="onModalClose" @confirm="onConfirm">
    <slot></slot>
    <el-table
      v-loading="landingPageModel.loading"
      border
      class="common-el-table-styles summary-el-table-styles"
      :height="222"
      :data="landingPageModel.tableData"
    >
      <el-table-column label="" width="55">
        <template slot-scope="{ row }">
          <el-radio v-model="landingPageModel.pageId" :label="row.siteId">&ensp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column prop="siteId" label="落地页ID" width="140"> </el-table-column>
      <el-table-column prop="name" label="落地页名称" width="140"> </el-table-column>
      <el-table-column prop="url" label="落地页地址"> </el-table-column>
      <el-table-column label="预览图" width="70">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openUrl(row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <template #foot-left>
      <el-pagination
        @current-change="getList"
        :current-page.sync="landingPageModel.pager.pageIndex"
        :page-size="landingPageModel.pager.pageSize"
        style="text-align: left"
        background
        layout="prev, pager, next, total"
        :total="landingPageModel.total"
      >
      </el-pagination>
    </template>
  </Modal>
</template>

<script setup>
import { reactive } from 'vue'
import { siteGetList } from '@/api/toutiao.model'
import Modal from '@/views/create/gdt/components/distribute/components/modal.vue'

// eslint-disable-next-line
const emits = defineEmits(['cancel', 'confirm'])
// eslint-disable-next-line
const props = defineProps({ adAccountId: Number })

const landingPageModel = reactive({
  loading: false,
  searchValue: '',
  tableData: [],
  pageId: '',
  total: 0,
  pager: {
    pageIndex: 1,
    pageSize: 10
  }
})

function onConfirm() {
  if (!landingPageModel.pageId) return
  emits(
    'confirm',
    landingPageModel.tableData.find((item) => item.siteId === landingPageModel.pageId)
  )
}

function onModalClose() {
  emits('cancel')
  landingPageModel.pageId = null
  landingPageModel.searchValue = ''
  landingPageModel.pager = {
    pageIndex: 1,
    pageSize: 10
  }
}

function getList() {
  if (landingPageModel.loading) return
  landingPageModel.loading = true
  siteGetList({
    account: props.adAccountId,
    pageIndex: landingPageModel.pager.pageIndex,
    pageSize: landingPageModel.pager.pageSize,
    search: landingPageModel.searchValue
  })
    .then((data) => {
      console.log('datadatadata output: ', data)
      if (data) {
        const { list, page_info } = data
        const { total_number } = page_info || {}
        if (list?.length) {
          landingPageModel.tableData = list
        } else {
          landingPageModel.tableData = []
        }
        landingPageModel.total = total_number
      }
    })
    .finally(() => {
      landingPageModel.loading = false
    })
}
function onModalOpen() {
  getList()
}

function openUrl(row) {
  window.open(row.url, '_blank')
}
</script>

<style lang="scss" scoped></style>
